import React from 'react';

import styles from './MessagesContainer.module.scss';

const DEFAULT_ACK_TEXT = 'Feedback has been received, thanks for improving us!';

interface FeedbackAckBubbleProps {
    /** The ack copy from the backend; falls back to the canned message. */
    content?: string;
    /** Registers the rendered node into the copy-full-chat ref map (mirrors CitationAnswer). */
    registerContentRef: (el: HTMLElement) => void;
}

/**
 * The distinct bubble shown for a feedback acknowledgement (flow_key='feedback').
 * Rendered in place of the normal assistant answer when a message is flagged as a
 * feedback ack (isFeedbackAck / metadata.feedback_ack) — see MessagesContainer.
 */
const FeedbackAckBubble: React.FC<FeedbackAckBubbleProps> = ({ content, registerContentRef }) => (
    <div
        className={styles.FeedbackAckBubble}
        data-testid="feedback-ack-bubble"
        ref={(el) => {
            if (el) registerContentRef(el);
        }}
    >
        <span className={styles.FeedbackAckIcon} aria-hidden="true">
            ✓
        </span>
        {content || DEFAULT_ACK_TEXT}
    </div>
);

export default FeedbackAckBubble;
